module.exports = __webpack_public_path__ + "static/media/Splash.086e203f.jpg";